import { render } from "./relive-memories-block.vue?vue&type=template&id=0df6e592&scoped=true"
import script from "./relive-memories-block.vue?vue&type=script&lang=js"
export * from "./relive-memories-block.vue?vue&type=script&lang=js"

import "./relive-memories-block.vue?vue&type=style&index=0&id=0df6e592&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0df6e592"]])

export default __exports__